import {gql} from 'apollo-angular';


export const insuranceDetailsGql = gql`
query ReloadInsuranceDetailsQuery($participantId: [Int!]) {
  Participant(participantId: $participantId) {
    participantId
    event {
      eventId
    }
    individualConstituent {
      allergies
      currentMedicalConditions
      currentMedications
      insuranceCompany            
    }
  }
}
`;